<template>
  <div class="tabs-layout">
    <draggable 
      tag="ul"
      class="nav nav-tabs small-tabs bg-transparent px-0 pt-1"
      :list="tabs"      
    >
      <li v-for="(tab, index) in tabs" :key="tab.fullPath" class="nav-item">
        <a
          class="nav-link"
          :class="{ active: tab.fullPath === $route.fullPath }"
          @click="goToTab(tab)"
        >          
          <span
            @click.stop="togglePin(tab)"
            class="text-muted ml-2"
            :title="tab.pinned ? 'Desfijar' : 'Fijar'"
            v-if="!tab.pinned"
          >
            📌
          </span>  

          {{ tab.title }}

          <span 
            @click.stop="closeTab(index)" 
            class="text-danger ml-2 close-x"
            title="Cerrar"
          >
            ×
          </span>          
        </a>
      </li>
    </draggable>

    <div class="p-0 pt-1">
      <keep-alive>
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </div>
  </div>
</template>


<script>
  import {EventBus} from '@/handler/event-bus'
  import draggable from 'vuedraggable'

  export default {
    components: {
      draggable,
    },
    data() {
      return {
        tabs: []
      }
    },
    created () {
      // Agrega la primera vista como tab inicial
      this.tabs.push({
        title: (this.$route.meta && this.$route.meta.title && this.$route.meta.title.toUpperCase()) || (this.$route.name && this.$route.name.toUpperCase()) || this.$route.path.toUpperCase(),
        fullPath: this.$route.fullPath,
        pinned: false
      });

      EventBus.$on('Update:TabTitle', title => {
        this.refreshActiveTabTitle(title.toUpperCase())
      })
    },    
    watch: {
      $route(to) {
        const exists = this.tabs.find(tab => tab.fullPath === to.fullPath);
        if (exists) return;

        // Busca una tab no fijada para reutilizar
        const index = this.tabs.findIndex(tab => !tab.pinned);
        const newTab = {
          title: (to.meta && to.meta.title && to.meta.title.toUpperCase()) || (to.name && to.name.toUpperCase()) || to.path.toUpperCase(),
          fullPath: to.fullPath,
          pinned: false
        };

        if (index !== -1) {
          // Reemplaza la no fijada
          this.$set(this.tabs, index, newTab);
        } else {
          // Todas están fijadas, agrega una nueva
          this.tabs.push(newTab);
        }
      }
    },
    methods: {
      goToTab(tab) {
        if (tab.fullPath !== this.$route.fullPath) {
          this.$router.push(tab.fullPath).catch(() => {});
        }
      },
      closeTab(index) {
        const closed = this.tabs.splice(index, 1)[0];
        if (closed.fullPath === this.$route.fullPath) {
          const next = this.tabs[index - 1] || this.tabs[0];
          if (next) this.$router.push(next.fullPath);
        }
      },
      refreshActiveTabTitle(title) {
        const currentPath = this.$route.fullPath;        
        const index = this.tabs.findIndex(tab => tab.fullPath === currentPath);
        if (index !== -1) {          
          this.$set(this.tabs, index, {
            ...this.tabs[index],
            title
          });
        }
      },
      togglePin(tab) {
        tab.pinned = !tab.pinned;
      }      
    }
  }
</script>

<style scoped>
  .small-tabs .nav-link {
    font-size: 0.85rem;
    padding: 4px 4px 2px 4px;
    margin-right: 4px;
    border-radius: 4px;
    background-color: transparent;
    border: 1px solid transparent;
    color: #333;
    transition: background-color 0.2s ease;   
  }

  .small-tabs .nav-link.active {
    background-color: #e9ecef; /* sombra suave */
    border: 1px solid #ced4da;
    font-weight: bold;         /* texto en negrita */
    color: #212529;
  }

  .small-tabs .text-danger {
    font-size: 0.85rem;
    margin-left: 6px;
    cursor: pointer;
  }

  .main > .tabs-layout + * {
    margin-top: 1rem;
  }  

  .small-tabs {
    overflow-x: auto;
    overflow-y: hidden; 
    white-space: nowrap;
    flex-wrap: nowrap;
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* Firefox */
  }

  /* WebKit (Chrome, Edge, Safari) */
  .small-tabs::-webkit-scrollbar {
    height: 4px;
  }

  .small-tabs::-webkit-scrollbar-track {
    background: transparent;
  }

  .small-tabs::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }

  .small-tabs {
    border-bottom: none;
  }
  .small-tabs .nav-link {
    border: none;
  }    

  .close-x {
    font-size: 0.85rem;
    margin-left: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .close-x:hover {
    font-weight: bold;
    text-decoration: underline;
  }  
</style>